import styles from './styles';
import { InputLabel, withStyles } from '@material-ui/core';

//@ts-ignore
export default withStyles(styles)(InputLabel);
